__turbopack_context__.v({
  "buttonBarItem": "PlasmicButtonBar-module__QwF2VG__buttonBarItem",
  "text": "PlasmicButtonBar-module__QwF2VG__text",
  "wrapper": "PlasmicButtonBar-module__QwF2VG__wrapper",
});
